import { isArray } from 'lodash';
import { race } from 'redux-saga/effects';

export function handleWorker({ handler, cancelled }) {
  return function*(data) {
    if (cancelled) {
      if (isArray(cancelled)) {
        yield race([handler(data), ...cancelled]);
        return;
      }

      yield race([handler(data), cancelled]);
      return;
    }

    yield handler(data);
  };
}
